import { createFeatureSelector } from "@ngrx/store";
import { User } from "../beans/User";
import { RootKeys } from "./app.model";

export const RootSelectors = {
    USER: createFeatureSelector<User>(RootKeys.user_store),
    REFERENCE_DATA: createFeatureSelector<any>(RootKeys.reference_data),
}